import React from 'react';

import './WpContainerHeader.scss';

export interface Props {
  children?: React.ReactNode;
}

const WpContainerHeader: React.FC<Props> = ({ children }: Props) => {
  const classNamePrefix = 'WpContainerHeader';

  return <div className={classNamePrefix}>{children}</div>;
};

export default WpContainerHeader;
